import * as React from 'react';
import { ArticleHeading3, UIText1, Image } from '@cian/ui-kit';
import { IBank } from '../../types/developer/banks';
import * as styles from './BankCard.css';

interface IBankCardProps {
  bank: IBank;
}

export function BankCard({ bank }: IBankCardProps) {
  return (
    <article key={bank.id} className={styles['card']}>
      <div className={styles['card__image']}>
        <Image src={bank.logo} width={48} height={48} objectFit="cover" data-testid="BankCardImage" />
      </div>

      <div className={styles['card__title']}>
        <ArticleHeading3 data-testid="BankCardTitle">{bank.name}</ArticleHeading3>
      </div>

      <div className={styles['card__items']}>
        <div className={styles['card__item']}>
          <UIText1>Процентная ставка</UIText1>
          <UIText1 fontWeight="700" data-testid="BankCardInterestRate">
            {bank.interestRate}
          </UIText1>
        </div>

        <div className={styles['card__item']}>
          <UIText1>Первый взнос</UIText1>
          <UIText1 fontWeight="700" data-testid="BankCardDownPayment">
            {bank.downPayment}
          </UIText1>
        </div>
      </div>
    </article>
  );
}
